import type { GAEventPayload } from "rivals/shared/analytics";
import { PurchasablePlan } from "rivals/shared/constants";
import { Subscription } from "rivals/shared/interfaces/Subscription";

export interface DispatchProps {
  getSubscriptions: () => void;
  reactivateSubscription: (subscriptionId: number) => void;
  sendGAEvent: (event: GAEventPayload) => void;
}

export interface StateProps {
  isLoading: boolean;
  isSubmitting: boolean;
  subscriptions?: Subscription[];
  subscriptionsConstants?: RailsConstants;
}

export interface GiftInfo {
  priceBeforeTax: number;
  tax: number;
  totalPrice: number;
}

export interface GiftPricing {
  priceBeforeTax: number;
  tax: number;
  totalPrice: number;
}

export interface GiftPlan {
  displayName: string;
  subscriptionLength: number;
  subscriptionLengthUnit: "month" | "year";
  totalPrice: number;
}

export function isGiftPlan(plan: PurchasablePlan | GiftPlan): plan is GiftPlan {
  return (plan as GiftPlan).subscriptionLength !== undefined;
}

export interface PricingConstants {
  annualCostDollars: string;
  autoRenewalOptInStates: string[];
  giftPlans: GiftPlan[];
  monthlyCostDollars: string;
  monthlySavings: string;
  tax?: number;
}

export interface RailsConstants {
  addSubscriptionButtonText: string;
  addSubscriptionTitle: string;
  cancelSubscriptionText: string;
  copyLinkButtonText: string;
  freeAccount: string;
  freeAccountInformation: string;
  header: string;
  promoCopyLink: string;
  referralDescription: string;
  referralDisclaimer: string;
  referralTitle: string;
  referralUrl: string;
  referralUrlTitle: string;
  selectATeam: string;
  upgradeToAnnual: string;
  userInitiatedCancellationsEnabled: boolean;
}

export interface SubscriptionDetails {
  id?: number;
  name?: string;
  plan?: string;
}
